module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.obj) ? _c('div', {
    class: 'callout callout-' + _vm.obj.type
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.obj.text)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e82c3ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Message.vue
// module id = 1826
// module chunks = 2